import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../config.service';
import { InitialWorkInfoModel } from '../../models/work-info/initial-work-info.model';
import { Observable } from 'rxjs';
import { WorkInfoModel } from '../../models/work-info/work-info.model';
import { WorkInfoOrderChangedModel } from '../../models/work-info/work-info-order-changed.model';
import { WorkInfoCostCenterChangedModel } from '../../models/work-info/work-info-cost-center-changed.model';
import { WorkInfoOperationChangedModel } from '../../models/work-info/work-info-operation-changed.model';
import { WorkInfoAbsenceChangedModel } from '../../models/work-info/work-info-absence-changed.model';
import { WorkInfoBasic } from '../../models/client-models';

const WORKINFO_ENDPOINT = 'workInfo';

/**
 * Access work info controller form backend.
 */
@Injectable({
  providedIn: 'root',
})
export class WorkInfoBackendService {
  constructor(private http: HttpClient) {}

  /**
   * Get initial work info state from backend.
   *
   * @param initialWorkInfo
   */
  public getInitialState(
    initialWorkInfo: InitialWorkInfoModel
  ): Observable<WorkInfoModel> {
    return this.http.post<WorkInfoModel>(
      AppConfig.settings.backend.url + WORKINFO_ENDPOINT + '/initial',
      initialWorkInfo
    );
  }

  /**
   * New Order selected.
   *
   * @param workInfoOrderChanged new order info.
   */
  public newOrderSelected(
    workInfoOrderChanged: WorkInfoOrderChangedModel
  ): Observable<WorkInfoModel> {
    return this.http.post<WorkInfoModel>(
      AppConfig.settings.backend.url + WORKINFO_ENDPOINT + '/order',
      workInfoOrderChanged
    );
  }

  /**
   * New cost center selected.
   *
   * @param workInfoCostCenterChanged new cost center info.
   */
  public newCostCenterSelected(
    workInfoCostCenterChanged: WorkInfoCostCenterChangedModel
  ): Observable<WorkInfoModel> {
    return this.http.post<WorkInfoModel>(
      AppConfig.settings.backend.url + WORKINFO_ENDPOINT + '/costCenter',
      workInfoCostCenterChanged
    );
  }

  /**
   * New operation selected.
   *
   * @param operation new operation info.
   */
  public newOperationSelected(
    operation: WorkInfoOperationChangedModel
  ): Observable<WorkInfoModel> {
    return this.http.post<WorkInfoModel>(
      AppConfig.settings.backend.url + WORKINFO_ENDPOINT + '/operation',
      operation
    );
  }

  /**
   * New absence selected.
   *
   * @param absence new info of selected absence.
   */
  public newAbsenceSelected(
    absence: WorkInfoAbsenceChangedModel
  ): Observable<WorkInfoModel> {
    return this.http.post<WorkInfoModel>(
      AppConfig.settings.backend.url + WORKINFO_ENDPOINT + '/absence',
      absence
    );
  }

  /**
   * Get work info for change time entry form.
   *
   * @param parameter
   */
  public getWorkInfoChange(
    parameter: WorkInfoBasic
  ): Observable<WorkInfoModel> {
    return this.http.post<WorkInfoModel>(
      AppConfig.settings.backend.url + WORKINFO_ENDPOINT + '/change',
      parameter
    );
  }

  public getWorkInfoBarcode(
    barcode: string,
    idPerson: number
  ): Observable<WorkInfoModel> {
    if (!barcode.startsWith('*')) {
      barcode = '*' + barcode + '*';
    }

    return this.http.post<WorkInfoModel>(
      AppConfig.settings.backend.url + 'barcode' + '/workInfo',
      {
        barcode,
        idPerson,
      }
    );
  }
}
